(function(){
  'use strict';

  var TARGET_PAGE_RE = /(^|\s)page-handle-(contact|about-us|over-ons)(\s|$)/;
  var mobileMQ = window.matchMedia ? window.matchMedia('(max-width: 991.98px)') : null;
  var desktopMQ = window.matchMedia ? window.matchMedia('(min-width: 992px)') : null;

  function isMobile(){ return !mobileMQ || mobileMQ.matches; }
  function isDesktop(){ return !!desktopMQ && desktopMQ.matches; }
  function isTargetPage(){ return !!document.body && TARGET_PAGE_RE.test(document.body.className || ''); }
  function setImp(el, prop, val){ if(el && el.style) el.style.setProperty(prop, val, 'important'); }
  function rem(el, prop){ if(el && el.style) el.style.removeProperty(prop); }

  function findMarquee(){
    return document.querySelector('.shopify-section-group-header-group [id*="__marquee"]') ||
           document.querySelector('[id*="__marquee"]') ||
           document.querySelector('.l4v-marquee, .marquee-bar, .announcement-bar, .marquee');
  }

  function marqueeBottom(){
    var m = findMarquee();
    if(m){
      var r = m.getBoundingClientRect();
      if(r && isFinite(r.bottom) && r.bottom > 0) return Math.round(r.bottom);
      if(r && isFinite(r.height) && r.height > 0) return Math.round(r.height);
    }
    var cs = getComputedStyle(document.documentElement);
    return Math.round(parseFloat(cs.getPropertyValue('--l4v-topbar-1')) || parseFloat(cs.getPropertyValue('--l4v-drawer-topbar-only')) || 40);
  }

  function placeDrawer(drawer, type){
    if(!drawer || !isMobile()) return;
    var top = marqueeBottom();
    document.documentElement.style.setProperty('--l4v-active-drawer-top', top + 'px');

    if(drawer.parentElement !== document.body){
      document.body.appendChild(drawer);
    }

    document.body.classList.toggle('l4v-menu-drawer-active', type === 'menu');
    document.body.classList.toggle('l4v-cart-drawer-active', type === 'cart');

    setImp(drawer, 'position', 'fixed');
    setImp(drawer, 'top', top + 'px');
    setImp(drawer, 'left', type === 'menu' ? '0' : 'auto');
    setImp(drawer, 'bottom', 'auto');
    setImp(drawer, 'height', 'calc(100dvh - ' + top + 'px)');
    setImp(drawer, 'max-height', 'calc(100dvh - ' + top + 'px)');
    setImp(drawer, 'margin-top', '0');
    setImp(drawer, 'padding-top', '0');
    setImp(drawer, 'border-top', '0');
    setImp(drawer, 'z-index', '2147483000');
    setImp(drawer, 'filter', 'none');
    setImp(drawer, '-webkit-filter', 'none');
    setImp(drawer, 'backdrop-filter', 'none');
    setImp(drawer, '-webkit-backdrop-filter', 'none');

    requestAnimationFrame(function(){
      document.querySelectorAll('.offcanvas-backdrop.show').forEach(function(b){
        setImp(b, 'z-index', '2147482990');
      });
    });
  }

  function forceDesktopCartClose(){
    if(!isDesktop()) return;
    document.querySelectorAll('#offcanvas-cart .offcanvas-header button.btn-close, #offcanvas-cart button.btn-close.l4v-cart-drawer-close').forEach(function(btn){
      ['width','height','min-width','min-height','max-width','max-height'].forEach(function(p){ setImp(btn, p, '18px'); });
      setImp(btn, 'padding', '0');
      setImp(btn, 'border-radius', '999px');
      setImp(btn, 'background-size', '7px 7px');
      setImp(btn, 'background-position', 'center center');
      setImp(btn, 'background-repeat', 'no-repeat');
      setImp(btn, 'background-color', 'rgba(255,255,255,.88)');
      setImp(btn, 'box-shadow', '0 3px 8px rgba(31,36,40,.08)');
      setImp(btn, 'opacity', '1');
      setImp(btn, 'transform', 'none');
    });
  }

  function cleanup(type){
    if(type === 'menu') document.body && document.body.classList.remove('l4v-menu-drawer-active');
    if(type === 'cart') document.body && document.body.classList.remove('l4v-cart-drawer-active');
    document.querySelectorAll('.offcanvas-backdrop').forEach(function(b){ rem(b, 'z-index'); });
  }

  function refreshActive(){
    if(!isMobile()) return;
    var menu = document.getElementById('offcanvas-menu');
    var cart = document.getElementById('offcanvas-cart');
    if(cart && (cart.classList.contains('show') || cart.classList.contains('showing'))){ placeDrawer(cart, 'cart'); return; }
    if(menu && isTargetPage() && (menu.classList.contains('show') || menu.classList.contains('showing'))){ placeDrawer(menu, 'menu'); }
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', forceDesktopCartClose, {once:true});
  else forceDesktopCartClose();
  window.addEventListener('load', forceDesktopCartClose, {once:true, passive:true});

  document.addEventListener('show.bs.offcanvas', function(e){
    if(!e.target) return;
    if(e.target.id === 'offcanvas-cart'){
      cleanup('menu');
      placeDrawer(e.target, 'cart');
      forceDesktopCartClose();
      requestAnimationFrame(function(){ placeDrawer(e.target, 'cart'); });
    }
    if(e.target.id === 'offcanvas-menu' && isTargetPage()){
      cleanup('cart');
      placeDrawer(e.target, 'menu');
      requestAnimationFrame(function(){ placeDrawer(e.target, 'menu'); });
    }
  });

  document.addEventListener('shown.bs.offcanvas', function(e){
    if(e.target && e.target.id === 'offcanvas-cart') placeDrawer(e.target, 'cart');
    if(e.target && e.target.id === 'offcanvas-menu' && isTargetPage()) placeDrawer(e.target, 'menu');
  });

  document.addEventListener('hidden.bs.offcanvas', function(e){
    if(e.target && e.target.id === 'offcanvas-cart') cleanup('cart');
    if(e.target && e.target.id === 'offcanvas-menu') cleanup('menu');
  });

  window.addEventListener('resize', function(){ refreshActive(); forceDesktopCartClose(); }, {passive:true});
  window.addEventListener('orientationchange', function(){ setTimeout(refreshActive, 160); }, {passive:true});
})();
